/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserTracksDownloadCountResponse
 */
export interface UserTracksDownloadCountResponse {
    /**
     * Total download count for all tracks (and stems) owned by the user
     * @type {number}
     * @memberof UserTracksDownloadCountResponse
     */
    data: number;
}

/**
 * Check if a given object implements the UserTracksDownloadCountResponse interface.
 */
export function instanceOfUserTracksDownloadCountResponse(value: object): value is UserTracksDownloadCountResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function UserTracksDownloadCountResponseFromJSON(json: any): UserTracksDownloadCountResponse {
    return UserTracksDownloadCountResponseFromJSONTyped(json, false);
}

export function UserTracksDownloadCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTracksDownloadCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function UserTracksDownloadCountResponseToJSON(value?: UserTracksDownloadCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

